module.exports = __webpack_public_path__ + "static/media/front.a83b1acd.png";